import React, { useMemo } from 'react';
import { ConfirmationModal } from '@@/ui/components';

interface BannerSaveConfirmationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
  originalHideLogin: boolean;
  newHideLogin: boolean;
  originalVisibility: boolean;
  newVisibility: boolean;
}

export const BannerSaveConfirmationModal: React.FC<BannerSaveConfirmationModalProps> = ({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
  originalHideLogin,
  newHideLogin,
  originalVisibility,
  newVisibility
}) => {
  const { description, destructive } = useMemo(() => {
    const parts: string[] = [];
    let isDestructive = false;

    if (originalHideLogin !== newHideLogin) {
      if (newHideLogin) {
        parts.push(
          'You are disabling login on the sign-in page. Users will be unable to authenticate until you re-enable login.'
        );
        isDestructive = true;
      } else {
        parts.push('Login via the sign-in page will be restored.');
      }
    }

    if (originalVisibility !== newVisibility) {
      if (newVisibility) {
        parts.push('The banner will become visible on the selected pages immediately.');
      } else {
        parts.push('The banner will no longer display on any page.');
        isDestructive = true;
      }
    }

    return {
      description: parts.join(' '),
      destructive: isDestructive
    };
  }, [originalHideLogin, newHideLogin, originalVisibility, newVisibility]);

  return (
    <ConfirmationModal
      title='Confirm banner changes'
      description={description}
      confirmButtonText='Confirm and save'
      cancelButtonText='Cancel'
      destructive={destructive}
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      isLoading={isLoading}
    />
  );
};

export default BannerSaveConfirmationModal;
